import { mapActions, mapGetters } from 'vuex';
import widgetEmptyState from '@/components/generics/widget-empty-state/widget-empty-state.vue';
import pinboardWidgetItem from '@/components/pinning/pinboard-widget-item/pinboard-widget-item.vue';
import pinboardWidgetSkeleton from '@/components/pinning/pinboard-widget-skeleton/pinboard-widget-skeleton.vue';
import loaderMixin from '@/mixins/loader';
import Contract from '@/models/contract';

const LIMIT = 5;

export default {
  mixins: [loaderMixin],
  components: {
    pinboardWidgetItem,
    widgetEmptyState,
    pinboardWidgetSkeleton,
  },
  computed: {
    ...mapGetters('widgets', ['getWidget']),
    items() {
      const markets = this.getWidget('new-arrivals').data || [];
      const contracts = [];
      markets.forEach((market) => {
        (market.contracts || []).forEach((contract) => {
          const c = new Contract(contract);
          contracts.push({
            contractId: contract.contractId,
            marketId: market.marketId,
            marketName: market.marketName,
            contractName: contract.contractName,
            price: c.lastTradePriceAsCents,
            changePrice: c.changePriceAsCents,
            hasLastTradePrice: c.hasLastTradePrice,
            lastClosePrice: contract.lastClosePrice,
          });
        });
      });
      return contracts.slice(0, LIMIT);
    },
  },
  methods: {
    ...mapActions('widgets', ['fetchNewArrivals']),
  },
  mounted() {
    if (this.getWidget('new-arrivals').data !== null) return;
    this.loaderAdd();
    this.fetchNewArrivals({ limit: LIMIT }).then(() => this.loaderRemove());
  },
};
